import { render, staticRenderFns } from "./catinfo.vue?vue&type=template&id=1dbbef9a&scoped=true&"
import script from "./catinfo.vue?vue&type=script&lang=js&"
export * from "./catinfo.vue?vue&type=script&lang=js&"
import style0 from "./catinfo.vue?vue&type=style&index=0&id=1dbbef9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbbef9a",
  null
  
)

export default component.exports